import {
  TaskDomainSchema,
  TaskPrioritySchema,
  TaskSubtypeSchema,
} from "@redotech/redo-model/task/task";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const taskRowSchema_ = z.object({
  id: z.string(),
  subtype: TaskSubtypeSchema,
  priority: TaskPrioritySchema,
  createdAt: z.date(),
  inventoryItemId: z.string().nullable(),
  productId: z.string().nullable(),
  productTitle: z.string().nullable(),
  productSku: z.string().nullable(),
});
export const taskRowSchema: z.ZodType<TaskRow> = taskRowSchema_;
export interface TaskRow extends z.infer<typeof taskRowSchema_> {}

export const getTasks = unaryRpc({
  name: "getTasks" as const,
  input: z.object({ domain: TaskDomainSchema.optional() }),
  output: z.object({ tasks: z.array(taskRowSchema) }),
});
